const env = import.meta.env;

const crypto = {
  btc: env.VITE_BTC_SUPPORT_ADDRESS?.trim() || null,
  eth: env.VITE_ETH_SUPPORT_ADDRESS?.trim() || null,
  usdcSol: env.VITE_USDC_SOL_SUPPORT_ADDRESS?.trim() || null,
};

const bmac = env.VITE_BMAC_SUPPORT_URL?.trim() || null;

const stripe = env.VITE_STRIPE_SUPPORT_URL?.trim() || null;

const hasCrypto = Object.values(crypto).some(Boolean);

const hasSupport = Boolean(bmac || stripe || hasCrypto);

const support = {
  bmac,
  stripe,
  crypto,
  hasCrypto,
  hasSupport,
};

export default support;
